import React from 'react';
import { observer } from 'mobx-react';
import AuthorisationVM from '../Services/AuthorisationVM';
import { Audit } from '@singularsystems/neo-react-services';
import { ModalUtils } from '@singularsystems/neo-core';

interface IAuthorisationComponentsProps {
    viewModel: AuthorisationVM;
}

@observer
export default class AuthorisationComponents extends React.Component<IAuthorisationComponentsProps> {

    constructor(props: IAuthorisationComponentsProps) {
        super(props);
    }

    public render() {
        const authorisationVM = this.props.viewModel;

        return (
            <>
                <Audit.ViewHistoryComponents viewModel={authorisationVM.auditVM} viewType="Custom" />
                <Audit.ViewHistoryModal viewModel={authorisationVM.auditVM}
                    acceptButton={
                        (() => {
                            if (authorisationVM.showPreAuthoriseButton || authorisationVM.showAuthoriseButton) {
                                return {
                                    text: authorisationVM.showPreAuthoriseButton ? "Pre-Authorise"
                                                                                 : (authorisationVM.isAuthorisingDelete ? "Authorise Delete" : "Authorise"),
                                    icon: "stamp",
                                    onClick: () => {
                                        if (authorisationVM.isAuthorisingDelete) {
                                            ModalUtils.showYesNo("Delete", `Are you sure you want to delete this record?`,
                                                () => authorisationVM.authorise());
                                        }
                                        else {
                                            authorisationVM.authorise();
                                        }
                                    }
                                };
                            } else {
                                return undefined;
                            }
                        })()
                    }
                />
            </>
        );
    }
}